export default class QuestionsFilter {

  constructor(container, onUpdateCallback) {
    this.container = container;
    this.onUpdateCallback = onUpdateCallback;
    this.resetButton = this.container.find('.c-questions-filter__reset-button')[0];
    this.sectorSelect = this.container.find('select[name="sector"]')[0];
    this.topicSelect = this.container.find('select[name="topic"]')[0];
    this.sectorSelectize = null;
    this.topicSelectize = null;

    this.containerID = Math.random().toString(36).substr(2, 9);
    this.sectorSelectID = Math.random().toString(36).substr(2, 9);
    $(this.container).attr('id', this.containerID);
    $(this.sectorSelect).parent().attr('id', this.sectorSelectID);

    this.init();
  }

  init() {
    var that = this;

    this.sectorSelectize = $(this.sectorSelect).selectize({
      placeholder: $(that.sectorSelect).attr('data-placeholder'),
      maxItems: 1,
      plugins: ['remove_button'],
    })[0].selectize;

    this.topicSelectize = $(this.topicSelect).selectize({
      placeholder: $(that.topicSelect).attr('data-placeholder'),
      maxItems: 100,
      plugins: ['remove_button'],
    })[0].selectize;

    $(this.resetButton).click(function(){
      that.sectorSelectize.setValue(null);
      that.topicSelectize.setValue(null);
    });

    $('#' + this.containerID +' select').on('change', function(){
      that.updateAfterSelection($(this));
    });
  }

  updateAfterSelection() {
    var filters = {};

    if ($(this.topicSelect).val() != '' && $(this.topicSelect).val() != null) {
      filters['topic'] = $(this.topicSelect).val();
    }

    if ($(this.sectorSelect).val() != '' && $(this.sectorSelect).val() != null) {
      filters['sector'] = $(this.sectorSelect).val();
    }

    this.onUpdateCallback(filters);
  }
}



// WEBPACK FOOTER //
// ./scripts/components/questions-filter.js